import { US_STATES, CA_PROVINCES } from "../../lib/regions";

const inputCls =
  "w-full rounded border border-[#D9CBB8] bg-white px-3 py-2 text-sm text-[#2C2724] focus:outline-none focus:border-[#4B3A2F]";

const Field = ({ label, children }) => (
  <label className="block">
    <span className="text-[10px] uppercase tracking-[0.25em] text-[#6D5A50]">{label}</span>
    <div className="mt-1">{children}</div>
  </label>
);

export const AddressForm = ({ value, onChange }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  const regions = value.country_code === "CA" ? CA_PROVINCES : US_STATES;
  return (
    <div className="grid grid-cols-2 gap-3" data-testid="shop-address-form">
      <div className="col-span-2"><Field label="Full name"><input className={inputCls} value={value.name} onChange={set("name")} data-testid="shop-address-name" autoComplete="name" /></Field></div>
      <div className="col-span-2"><Field label="Email (for your receipt & tracking)"><input type="email" className={inputCls} value={value.email} onChange={set("email")} data-testid="shop-address-email" autoComplete="email" /></Field></div>
      <div className="col-span-2"><Field label="Street address"><input className={inputCls} value={value.address1} onChange={set("address1")} data-testid="shop-address-line1" autoComplete="address-line1" /></Field></div>
      <div className="col-span-2"><Field label="Apt, suite (optional)"><input className={inputCls} value={value.address2} onChange={set("address2")} data-testid="shop-address-line2" autoComplete="address-line2" /></Field></div>
      <Field label="City"><input className={inputCls} value={value.city} onChange={set("city")} data-testid="shop-address-city" autoComplete="address-level2" /></Field>
      <Field label="Country">
        <select className={inputCls} value={value.country_code} onChange={(e) => onChange({ ...value, country_code: e.target.value, state_code: "" })} data-testid="shop-address-country">
          <option value="US">United States</option>
          <option value="CA">Canada</option>
        </select>
      </Field>
      <Field label={value.country_code === "CA" ? "Province" : "State"}>
        <select className={inputCls} value={value.state_code} onChange={set("state_code")} data-testid="shop-address-state">
          <option value="">Choose…</option>
          {regions.map(([code, name]) => <option key={code} value={code}>{name}</option>)}
        </select>
      </Field>
      <Field label={value.country_code === "CA" ? "Postal code" : "ZIP code"}><input className={inputCls} value={value.zip} onChange={set("zip")} data-testid="shop-address-zip" autoComplete="postal-code" /></Field>
    </div>
  );
};

export const EMPTY_ADDRESS = {
  name: "", email: "", address1: "", address2: "", city: "", state_code: "", country_code: "US", zip: "",
};
